import React from "react";
import PartnerLogo from './logo-partner';

import {
  Card,
  CardLinkWrapper,
  CardMediaLogo,
  CardContent,
  CardTitle,
  CardUrl,
  CardLocation,
  CardType
} from "../main/card"


const PartnerCard = ({ className, data, recordId }) => {
    let path_url = data.name
      .replace(/\./g, "")
      .replace(/&/g, "")
      .replace(/\s/g, "")
      .replace(/-/g, "")
      .replace(/é/g, "e")
    
    return (
      <CardLinkWrapper
        className={className}
        active="true"
        cardLink={`/partners/` + decodeURIComponent(path_url)}
      >
        <Card>
          <CardMediaLogo logo={<PartnerLogo id={recordId} />} />
          <CardContent>
            <CardTitle>{data.name}</CardTitle>
            <CardLocation country={data.hq_country} city="" />
            <CardType type={data.type} />
            <CardUrl url={data.url} />
          </CardContent>
        </Card>
      </CardLinkWrapper>
    )
}

export default PartnerCard;